import React, { useEffect, useState } from 'react';
import { format, isSameDay, parseISO } from 'date-fns';

import { FaExclamationCircle } from 'react-icons/fa';
import { Button } from 'react-bootstrap';
import Modal from '../../Modal';
import { IAgendamentosPaciente } from '..';

type prps = {
  AgeCodigo?: number;
  ConCodigo: number;
  agendamentos: IAgendamentosPaciente[];
  data: Date;
  handleFecharAgendamento(): void;
};

const AlertaConsultaDia: React.FC<prps> = ({
  AgeCodigo = 0,
  ConCodigo,
  data,
  agendamentos,
  handleFecharAgendamento,
}) => {
  const [exibeAlerta, setExibeAlerta] = useState<string>();

  useEffect(() => {
    const agendamentoMesmaAgendaEDia = agendamentos.find(
      age =>
        age.AgeCodigo !== AgeCodigo &&
        age.ConCodigo === ConCodigo &&
        isSameDay(parseISO(age.AgeInicio.toString()), data),
    );

    if (agendamentoMesmaAgendaEDia)
      setExibeAlerta(
        `Já existe um agendamento para esse paciente na data de ${format(
          parseISO(agendamentoMesmaAgendaEDia.AgeInicio.toString()),
          `dd/MM 'às' HH:mm`,
        )}, deseja realizar mais um agendamento?`,
      );
  }, [AgeCodigo, ConCodigo, agendamentos, data]);

  return (
    <>
      {exibeAlerta && (
        <Modal
          show={!!exibeAlerta}
          titulo="Alerta de Duplicidade"
          handleFecharModal={() => setExibeAlerta(undefined)}
          large={false}
        >
          <div className="text-center">
            <FaExclamationCircle size={48} color="#dc3545" />
            <h6>{exibeAlerta}</h6>
            <div className="d-flex justify-content-between">
              <Button
                type="button"
                variant="danger"
                size="sm"
                className="float-right ml-2"
                onClick={() => setExibeAlerta(undefined)}
              >
                Continuar mesmo assim
              </Button>

              <Button
                type="button"
                size="sm"
                className="float-right ml-2"
                onClick={handleFecharAgendamento}
              >
                Cancelar
              </Button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default AlertaConsultaDia;
